
@if (mainLayout) {
  <div class="page w-full h-full flex flex-col">
    <!-- Top navigation bar -->
    <pim-top-navigation [showSideNav]="showSideNav" (toggleSideNav)="toggleSideNav()"></pim-top-navigation>

    <div class="flex-1 page flex">
      @if (showSideNav) {
        <pim-main-navigation></pim-main-navigation>
      }
      <div class="page-wrapper flex-1">
        <div class="breadcrumbs">
          <pim-breadcrumbs-navigation></pim-breadcrumbs-navigation>
        </div>
        <div class="component-wrapper">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
  <pim-info-message></pim-info-message>
  <pim-modal></pim-modal>
} @else {
  <div class="bg-extend-background w-full h-full reducedLayout">
    <div class="flex justify-center items-center h-full">
      <router-outlet></router-outlet>
    </div>
  </div>
}
